/* eslint-disable react/react-in-jsx-scope */
// import Cookies from 'js-cookie';
import React, { useEffect, useReducer, useState } from 'react';
import { auth, fbProvider, googleProvider } from '../utils/firebase/';

const Store = React.createContext();

const initialState = {
	transport: {},
	origin: '',
	destination: '',
	distance: '',
};

const reducer = (state, action) => {
	switch (action.type) {
		case 'SELECT_TRANSPORT': {
			return { ...state, transport: action.payload };
		}
		case 'ORIGIN':
			return { ...state, origin: action.payload };
		case 'DESTINATION':
			return { ...state, destination: action.payload };
		case 'DISTANCE':
			return { ...state, distance: action.payload };
		default:
			return state;
	}
};
export const StoreConsumer = Store.Consumer;

export function StoreProvider({ children }) {
	const [state, dispatch] = useReducer(reducer, initialState);
	const [user, setUser] = useState();

	//sign in with Google
	const handleGoogleSignIn = () => {
		auth.signInWithPopup(googleProvider);
	};

	// Facebook log in Handler
	const handleFbSignIn = () => {
		auth.signInWithPopup(fbProvider);
	};

	useEffect(() => {
		auth.onAuthStateChanged((user) => {
			setUser(user);
		});
	}, []);

	const logout = () => {
		auth.signOut().then(() => {
			setUser(null);
		});
	};

	const value = {
		state,
		dispatch,
		user,
		handleGoogleSignIn,
		handleFbSignIn,
		logout,
	};
	return <Store.Provider value={value}>{children}</Store.Provider>;
}

export default Store;
